module.exports = __webpack_public_path__ + "img/watchlistadd.322d65ce.svg";